// https://www.gatsbyjs.org/docs/layout-components/#how-to-prevent-layout-components-from-unmounting
import React from "react";
import Layout from "./components/Layout";

// eslint-disable-next-line react/display-name
export default ({ element, props }: any) => {
  return <Layout {...props}>{element}</Layout>;
};
